import type { GitHubReposQueryVariables } from "gql-types/documents/web-client";
import {
  GitHubOrganizationsDocument,
  GitHubPersonalOrganizationDocument,
  GitHubReposDocument,
} from "gql-types/documents/web-client";

import { useQuery } from "./utils/useQuery";

export const useGitHubOrganizationsQuery = (shouldFetch = true) =>
  useQuery(shouldFetch ? GitHubOrganizationsDocument : null);

export const useGitHubPersonalOrganizationQuery = (shouldFetch = true) =>
  useQuery(shouldFetch ? GitHubPersonalOrganizationDocument : null);

export const useGitHubReposQuery = (variables?: GitHubReposQueryVariables) =>
  useQuery(variables ? GitHubReposDocument : null, variables);
